import React, { useState, FunctionComponent } from "react";
import Modal from "../modal";
import "./character-picker.scss";
import Button from "../button";
import { motion } from "framer-motion";
import classNames from "classnames";
import header from "../../assets/images/persona-header.svg"

declare const window: any;
interface CharacterPickerProps {
  isOpen?: boolean;
  onCharSelected: (char: any) => void;
}

export const characterData = [
  { 
    name: "Krampus",
    userNameBase: "Krampus",
    code: "kramp",
    imageSrc: require("../../assets/images/personas/kram.png"),
  },
  {
    name: "Santa Claus",
    userNameBase: "SantaClaus",
    code: "sant",
    imageSrc: require("../../assets/images/personas/sant.png"),
  },
  {
    name: "Bad Boy Steve",
    userNameBase: "BadBadBoy",
    code: "badb",
    imageSrc: require("../../assets/images/personas/badb.png"),
  },
  {
    name: "Nemo",
    userNameBase: "Nemo",
    code: "nemo",
    imageSrc: require("../../assets/images/personas/nemo.png"),
  },
  {
    name: "Schmanta",
    userNameBase: "Schmanta",
    code: "schm",
    imageSrc: require("../../assets/images/personas/schm.png"),
  },
  {
    name: "Rusty",
    userNameBase: "Rusty",
    code: "rust",
    imageSrc: require("../../assets/images/personas/rust.png"),
  },
  {
    name: "The Ghost of Christmas Past",
    userNameBase: "GhostofChristmas",
    code: "ghos",
    imageSrc: require("../../assets/images/personas/ghos.png"),
  },
  {
    name: "Disco Roger",
    userNameBase: "DiscoRoger",
    code: "disc",
    imageSrc: require("../../assets/images/personas/disc.png"),
  },
  {
    name: "Humbaba",
    userNameBase: "Humbaba",
    code: "humb",
    imageSrc: require("../../assets/images/personas/humb.png"),
  },

  {
    name: "Single Stan",
    userNameBase: "SingleStan",
    code: "sing",
    imageSrc: require("../../assets/images/personas/sing.png"),
  },
    {
    name: "Principal Lewis",
    userNameBase: "PrincipalLewis",
    code: "prin",
    imageSrc: require("../../assets/images/personas/prin.png"),
  },
  {
    name: "Michelle the Lawyer",
    userNameBase: "MichelleLawyer",
    code: "mich",
    imageSrc: require("../../assets/images/personas/mich.png"),
  },
];

export const getProfileIconFromDisplayName = (displayName: string) => {
  let characterOptions = characterData;

  let character = characterOptions[0];

  let code = displayName
    .toLowerCase()
    .replace(/[^a-z]/g, "")
    .substr(0, 4);
  const index = characterOptions.findIndex((p) => p.code === code) || 0;

  if (index >= 0) {
    //only if we found character
    character = characterOptions[index];
  }

  let imageIcon = character.imageSrc;

  return imageIcon;
};

const CharacterPicker: FunctionComponent<CharacterPickerProps> = ({
  isOpen,
  onCharSelected,
}) => {
  const [selectedCharacter, setSelectedCharacter] = useState<string>();

  function selectPersona(i: number) {
    window.bindTracking({
      type: "interaction-event",
      data: {
        interactionEvent: 1,
        screenName: "Select Personna",
        screenSection: "Select Personna",
        interactionName: "Select Personna",
      },
    });

    onCharSelected(characterData[i]);
    setSelectedCharacter(characterData[i].code);
  }

  const characterContainer = {
    hidden: { opacity: 1 },
    show: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.05,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 10 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        ease: "backOut",
      },
    },
  };

  const characters = characterData.map((character, i) => {
    const imageSrc = character.imageSrc;

    return (
      <motion.div
        variants={item}
        onClick={() => selectPersona(i)}
        className={classNames({
          persona: true,
          selected: selectedCharacter === character.code,
        })}
        key={i}
      >
        <div
          className="persona-image"
          style={{ backgroundImage: `url(${imageSrc})` }}
        ></div>
        <div className="persona-name">{character.name}</div>
      </motion.div>
    );
  });
  return (
    <Modal isOpen={isOpen}>
      <div className="character-picker-container relative">
        <div
          className={classNames({
            header: true,
            selected: selectedCharacter,
          })}
        >
          
          <img className="persona-header" src={header} alt=""/>
        </div>
        <motion.div
          className="character-picker"
          variants={characterContainer}
          initial="hidden"
          animate="show"
          exit={{ opacity: 0, scale: 0 }}
        >
          {characters}
        </motion.div>
      </div>
    </Modal>
  );
};

export default CharacterPicker;
